module.exports = __webpack_public_path__ + "static/index/img/baikal-902.2e18597c.jpg";